<template>
    <div class="content">
        <el-card class="box-card">
            <div class="box-cont">
                <h2>{{dwmc}}</h2>
                <p><el-tag v-if="cfjdWh" size="small" type="danger">{{cfjdWh}}</el-tag>
                    <el-tag v-if="zylb" size="small" type="success">{{zylb}}</el-tag>
                    <el-button type="warning" size="medium" @click="getXiazai()" style="float:right;margin-right:20px;">案卷下载</el-button>
                </p>
                <label><i>案由：</i>{{anyou}}</label>
                
            </div>
        </el-card>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">电子档案</span>
            </div>
            <div class="box-cont">
                <div class="lft">
                    <ul class="wslb">
                        <li v-for="(item,index) in data" :key="index">
                            <p @click="getActive(index)"><i  :class="isActive == index ?'el-icon-minus' :'el-icon-plus'"></i><span>{{item.label}}</span></p>
                            <ul class="wszlb" v-show="isActive == index">
                                <li v-for="(itema,i) in item.children" :key="i" @click="getActive2(i)" :class="isActive2 == i ?'active' :''">
                                    <label>{{itema.name}}</label>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div class="rt">
                    <ul class="wsUl">
                        <li v-for="(item,index) in wsList" :key="index">
                            <!-- <img :src="'/api/'+item.src" @click="getBg(item.src)" /> -->
                            <img :src="'https://dapc1.scqwszfd.cn:8123/'+item.src" @click="getBg(item.src,item.ym)" />
                            <!-- <img :src="'http://dagl.hzxhykj.com:8113/'+item.src" @click="getBg(item.src)" /> -->
                            <p>第{{item.ym}}页</p>
                        </li>
                    </ul>
                </div>
            </div>
        </el-card>
        <el-dialog :visible.sync="open" top="20px" :width="isH?'700px':'1200px'" append-to-body ref="rotate"  :close-on-click-modal="false">
            <el-button class="zAn" icon="el-icon-arrow-left" v-if="!yeshu1" :disabled="yeshu1" circle style="position:absolute;top:48vh;left:-50px;font-size:20px;" @click="ymJian()"></el-button>
            <el-button class="yAn" icon="el-icon-arrow-right" v-if="!yeshu2" :disabled="yeshu2" circle style="position:absolute;top:48vh;right:-50px;font-size:20px;" @click="ymJia()"></el-button>
            <div style="text-align:center; margin-bottom:20px;">
                <el-button type="warning" size="small" @click="rotate">旋转</el-button>
            </div>
            <p v-show="bgImg" ref="rotate" :style="{'width':isH?'100%':'70%'}" style="margin: 0px auto; max-width:700px; overflow-y: auto;">
                <img :src="'https://dapc1.scqwszfd.cn:8123/'+bgImg"  style="width: 100%;" />
                <!-- <img :src="'/api/'+bgImg" /> -->
                <!-- <img :src="'http://dagl.hzxhykj.com:8113/'+bgImg" /> -->
                
            </p>
        </el-dialog>
        <!-- <div class="bgTp" v-show="bgImg">
            <div style="text-align:center; position:absolute; top:70px; z-index: 100;width: 100%;">
                <el-button type="primary" size="small" icon="el-icon-refresh-right" @click="rotate">旋转</el-button>
                <el-button type="primary" size="small" icon="el-icon-close" @click="closeBg">关闭</el-button>
            </div>
            
        </div> -->
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
export default {
    name: "Layout",
    props:['object'],
    data() {
        return {
            loading:false,
            lsh:'',
            dwmc:'',
            cfjdWh:'',
            zylb:'',
            anyou:'',
            queryParams:{
                page:1,
                limit:10,
            },
            total:0,
            wsList:[],
            bgImg:'',
            data: [{
                label: '执法文书',
                children: []
                }, {
                label: '主体材料',
                children: []
                },{
                label: '证据材料',
                children: []
                },{
                label: '相关票据',
                children: []
                },],
            isActive:0,
            isActive2:0,
            url:'',
            deg:0,
            isH:true,
            open:false,
            url:'',
            yeshu1:false,
            yeshu2:false,
            dqYema:1
        }
    },
    components: {
    },
    computed: {
    },
    watch:{
        $route: {
            handler: function(route) {
                console.log(route)
                if(route.path == '/daxq'){
                    let row = JSON.parse(decodeURIComponent(route.params.object));
                    // console.log(row)
                    this.lsh = row.lsh
                    this.dwmc = row.dwmc
                    this.cfjdWh = row.cfjdWh
                    this.zylb = row.zylb
                    this.anyou = row.anyou
                    this.url = row.fileUrl
                    this.getList()
                }
            },
            immediate: true
        }
    },

    created() {
    },
    mounted() {
    },
    methods: {
        async getList(){
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getdzdaPdf&pcId=${this.lsh}`)
            if(data.data){
                console.log(data.data)
                let arr = data.data
                arr.forEach(item => {
                    if(item.leixing == '执法文书'){
                        this.data[0].children.push(item)
                    }else if(item.leixing == '主体材料'){
                        this.data[1].children.push(item)
                    }else if(item.leixing == '证据材料'){
                        this.data[2].children.push(item)
                    }else if(item.leixing == '相关票据'){
                        this.data[3].children.push(item)
                    }
                })

                if(this.data[0].children && this.data[0].children[0]){
                    this.getWs(this.data[0].children[0])
                }
                
            }
        },
        getWs(obj){
            this.wsList = []
            if(obj){
                if(obj.pageCount == 1){
                    let src = obj.fileUrl
                    this.wsList.push({src:src,ym:1})
                }else{
                    let mm = Number(obj.pageCount)
                    console.log(mm)
                    let  p = obj.fileUrl.split('.')
                    console.log(p)
                    let p1 = p[0].split('/anjian')
                    console.log(p1)
                    let pp = Number(p1[1])
                    console.log(pp)
                    for(var i=0;i<mm;i++){
                        if(this.isActive == 0 && this.isActive2 == 0){
                            let n = ''
                            if(i == 0){
                                n = ''
                            }else{
                                n = pp+i+1
                            }
                            let src = p1[0] +'/anjian'+n+'.'+p[1]
                            let ym = i == 0?1:1+i
                            this.wsList.push({src:src,ym:ym})
                        }else{
                            let src = p1[0] +'/anjian'+(i == 0?pp:pp+i)+'.'+p[1]
                            let ym = i == 0?1:1+i
                            this.wsList.push({src:src,ym:ym})
                        }
                    }
                }
                console.log(this.wsList)
            }
        },
        handleSizeChange(val){
            this.pagesize = val
            this.getList()
        },
        handleCurrentChange(val){
            this.pageshow = false;
            this.queryParams.page = val
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleNodeClick(data) {
            console.log(data);
        },
        getBg(src,val){
            this.dqYema = val
            this.bgImg = src
            this.open = true
            this.isH = true
            this.$refs.rotate.style.transform = `rotate(0deg)`
            if(this.wsList.length == 1){
                this.yeshu1 = true
                this.yeshu2 = true
            }else{
                if(Number(val) > 1){
                    if(Number(val) < this.wsList.length){
                        this.yeshu1 = false
                        this.yeshu2 = false
                    }else{
                        this.yeshu1 = false
                        this.yeshu2 = true
                    }
                }else{
                    this.yeshu1 = true
                    this.yeshu2 = false
                }
            }
        },
        ymJian(){
            let ym = Number(this.dqYema) - 1
            console.log(ym)
            let src = this.wsList[ym - 1].src
            this.getBg(src,ym)
        },
        ymJia(){
            let ym = Number(this.dqYema) + 1
            console.log(ym)
            let src = this.wsList[ym - 1].src
            this.getBg(src,ym)
        },
        // 旋转图片
        rotate () {
            this.isH = false
            this.deg += 90
            if (this.deg >= 360) {
                this.deg = 0
            }
            this.$refs.rotate.style.transform = `rotate(${this.deg}deg)`
        },
        closeBg(){
            this.bgImg = ''
            this.open = false
        },
        getActive(index){
            if(this.isActive == index){
                this.isActive = '-1'
            }else{
                this.isActive = index
            }
            this.isActive2 = 0
        },
        getActive2(index){
            this.isActive2 = index
            if(this.data[this.isActive].children && this.data[this.isActive].children[this.isActive2]){
                this.getWs(this.data[this.isActive].children[this.isActive2])
            }
        },
        getXiazai(){
            if(this.url){
                let fileUrl = ''
                if(this.url.indexOf('//')){
                    let url = this.url.replace(/\\/g,"/")
                    console.log(url)
                    fileUrl = 'https://dapc1.scqwszfd.cn:8123/'+url
                }else{
                    fileUrl = 'https://dapc1.scqwszfd.cn:8123/'+this.url
                }
                window.open(fileUrl,'_blank')
                // this.downloadRes(fileUrl)
                // const a = document.createElement('a')
                // a.href = fileUrl
                // a.download = this.dwmc // 下载后文件名
                // a.style.display = 'none'
                // document.body.appendChild(a)
                // a.click() // 点击下载
                // document.body.removeChild(a) //baseURL + "/common/download?fileName=" +  下载完成移除元素
            }else{
                this.$message({
                    message: '该案卷文档不存在！',
                    type: 'error'
                });
            }
        },
        async downloadRes(url){
            let response = await fetch(url); 
            let blob = await response.blob();  
            let objectUrl = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = objectUrl;
            a.download = res.success.fileName;
            a.click()
            a.remove(); 
        }
    }
}
</script>


<style scoped>
.box-cont{width: 100%; overflow: hidden;}
.box-cont h2{font-weight: bold;font-size: 18px;color: #000000;line-height: 36px;}
.box-cont >>> p .el-tag{margin-right: 10px;}
.box-cont >>> p .el-tag.el-tag--danger {
    background: #FFDADA;
    border-radius: 2px;
    border-color: #FFDADA;
    color: #F35757;
}
.box-cont >>> p .el-tag.el-tag--success {
    background-color: #DAEDFF;
    border-radius: 2px;
    border-color: #DAEDFF;
    color: #1890FF;
}
.box-cont label{ display: block; width: 100%; font-size: 14px;color: #000000;line-height: 36px;}
.box-cont label i{ color:#B3B3B3; font-style: normal;}
.lft{float: left; width: 228px;min-height: 600px; background: #FFFFFF;border: 1px solid #E6E6E6;}
.wslb{ padding: 12px 15px;}
.wslb p{font-size: 14px;color: #000000;line-height: 28px; cursor: pointer;}
.wslb p i{background: #FFFFFF;border-radius: 2px;border: 1px solid #808080; width: 14px; height: 14px; line-height:14px;font-size: 10px;text-align:center; margin-right: 10px; cursor: pointer;}
.wszlb{ width: 100%;}
.wszlb li{ width: 100%; background: #fff; cursor: pointer;}
.wszlb label{width: 180px; padding-left: 26px;font-size: 14px;color: #000000;line-height: 30px;}
.wszlb li.active{ background: #DAEDFF;}
.rt{float: right;width: calc(100% - 242px);min-height: 600px;background: #FFFFFF;border: 1px solid #E6E6E6;}
.wsUl{ width: calc(100% - 30px); overflow: hidden; padding:0 15px;}
.wsUl li {width:calc(20% - 10px); margin:20px 5px; float: left; text-align: center;}
.wsUl li img{width: 100%;border: 1px solid #E6E6E6;cursor: pointer;}
.bgTp{ position: fixed; top:0;left: 0; z-index: 1000; width: 100%; min-height: 100%; background: rgba(0, 0, 0, 0.5); text-align: center;}
.bgTp img{padding-top: 50px; width: 793px;}
.bgTp span{width: 780px; position: absolute; top:70px; text-align: right;}
.bgTp span i{ font-size: 20px; cursor: pointer;}
</style>